import { Injectable } from '@angular/core';

import { ChatProxyService } from './chat-proxy.service';
import { TripMessage, UserProfilesFilterDto } from '../models/chat-models';

@Injectable({
	providedIn: 'root'
})
export class ChatService {
	constructor(private chatProxyService: ChatProxyService) { }

	getTwilioToken = () => this.chatProxyService.getTwilioToken();

	createChannel = (friendExternalId: string) => this.chatProxyService.createChannel(friendExternalId);

	getAvailability = () => this.chatProxyService.getAvailability();

	setAvailability = (isAvailable: boolean) => this.chatProxyService.setAvailability(isAvailable);

	getUsersProfilesForMap = (lng: number, lat: number, rad: number) => this.chatProxyService.getUsersProfilesForMap(lng, lat, rad);

	getPublicUserProfiles = (
		filter: string,
		pageNumber: number,
		pageSize: number,
		isTrekmondo?: boolean,
		county?: string) =>
		this.chatProxyService.getPublicUserProfiles(filter, pageNumber, pageSize, isTrekmondo, county)

	getPublicProfilesByFilterCriteria = (
		filters: UserProfilesFilterDto) =>
		this.chatProxyService.getPublicProfilesByFilterCriteria(filters)

	sendTripMessage = (tripReferenceNumber: string) =>
		this.chatProxyService.sendTripMessage(tripReferenceNumber)
}
